import DateLib from 'utils/vue/lib/dates'
export default DateLib
export const {
  TIMEZONE,
  DateTime,
  Settings,
  Duration,
  Interval,
  now,
  dateReset,
  dateEndReset,
  todayStart,
  todayEnd,
  tomorrowStart,
  tomorrowEnd,
  parseDateTime,
  formatDate,
  parseDateInterval,
  getDate,
  getDayDate,
  getDayDateYear,
  getDateTime,
  getDateTimeYear,
  getNow,
  getNowSeconds,
  time2Min,
} = DateLib

